export default __webpack_public_path__ + "static/media/00.7793ca62.jpg";